<template>
    <div>
        <van-nav-bar
            title="新增预约"
            left-text="返回"
            left-arrow
            @click-left="clickback"
        />
        <van-field label="店铺" v-model="shopName" is-link readonly @focus="shopShow=true"></van-field>
        <van-action-sheet v-model="shopShow" :round="false" :actions="shopList" @select="onShopSelect" />
        <!-- <van-field v-model="complaint_date" disabled label="投诉时间" placeholder="请输入用户名" /> -->
        <van-field
            readonly
            clickable
            name="datetimePicker"
            :value="date"
            label="预计日期"
            placeholder="点击选择时间"
            @click="dateShowPicker = true"
        />
        <van-popup v-model="dateShowPicker" position="bottom">
            <van-datetime-picker
                type="date"
                v-model="currentDate"
                title="选择年月日"
                @confirm="onDateConfirm"
                @cancel="dateShowPicker = false"
            />
        </van-popup>
        <van-field
            readonly
            clickable
            name="datetimePicker"
            :value="time1"
            label="预计到店时间"
            placeholder="点击选择时间"
            @click="showPicker1 = true"
        />
        <van-popup v-model="showPicker1" position="bottom">
            <van-datetime-picker
                type="time"
                :filter="filter"
                @confirm="onTime1Confirm"
                @cancel="showPicker1 = false"
            />
        </van-popup>
        <van-field
            readonly
            clickable
            name="datetimePicker"
            :value="time2"
            label="最晚到店时间"
            placeholder="点击选择时间"
            @click="showPicker2 = true"
        />
        <van-popup v-model="showPicker2" position="bottom">
            <van-datetime-picker
                type="time"
                :filter="filter"
                @confirm="onTime2Confirm"
                @cancel="showPicker2 = false"
            />
        </van-popup>
        <van-field label="项目类别" v-model="categoryName" readonly is-link @focus="categoryShow=true"></van-field>
        <van-action-sheet v-model="categoryShow" :round="false" :actions="categoryList" @select="onCategorySelect" />
        <van-field label="项目名称" v-model="projectName" readonly is-link @focus="projectShow=true"></van-field>
        <van-action-sheet v-model="projectShow" :round="false" :actions="projectList" @select="onProjectSelect" />
        <van-field label="车辆" v-model="carName" is-link readonly @focus="carShow=true"></van-field>
        <van-action-sheet v-model="carShow" :round="false" :actions="carList" @select="onCarSelect" />
        <van-field
            v-model="from.rem"
            label="备注信息"
            type="textarea"
            placeholder="请输入备注信息"
        />

        <div style="margin: 10px;">
            <van-button round block type="info" native-type="submit" @click="postFrom">
            提交
            </van-button>
        </div>
    </div>
</template>

<script>
import { NavBar, Field, ActionSheet, Button, Toast, DatetimePicker, Popup } from 'vant';
import { UserShopInfoApi, ShopProjectApi } from '@/api/shop';
import { BookingApi, UserCarApi } from '@/api/vip';
import moment from 'moment'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Field.name]: Field,
        [ActionSheet.name]: ActionSheet,
        [Button.name]: Button,
        [Toast.name]: Toast,
        [DatetimePicker.name]: DatetimePicker,
        [Popup.name]: Popup
    },
    data() {
        return {
            shopShow: false,
            shopName: '',
            shopList: [],
            shopProjectList: [],
            categoryShow: false,
            categoryName: '',
            categoryList: [],
            category: 0,
            projectShow: false,
            projectName: '',
            projectList: [],
            carShow: false,
            carName: '',
            carList: [],

            currentDate: new Date(),
            date: moment(new Date()).format('YYYY-MM-DD'),
            dateShowPicker: false,
            time1: '08:00',
            showPicker1: false,
            time2: '09:00',
            showPicker2: false,
            from:{
                project_category: 1,
                shop: null,
                car: null,
                project_id: null,
                start_time: new Date(),
                end_time: new Date(),
                vip: null,
                rem:''
            }
        }
    },
    mounted(){
        this.getShopList()
    },
    methods: {
        onShopSelect(item) {
            this.shopShow = false
            this.shopName = item.name
            this.from.shop = item.shop_id
            this.from.vip = item.vip
            this.getShopProjectList()
        },
        onCategorySelect(item) {
            this.categoryShow = false
            this.categoryName = item.name
            this.shopProjectList.forEach(itemShopProject => {
                if(itemShopProject.category==item){
                    this.projectList = itemShopProject.service
                }
            })
        },
        onProjectSelect(item) {
            this.projectShow = false
            this.projectName =item.name
            this.from.project_id = item.id
        },
        onCarSelect(item) {
            this.carShow = false
            this.carName =item.name
            this.from.car = item.id
        },
        getShopList(){
            var that = this
            that.axios.get(UserShopInfoApi).then((ret) => {
                if (ret.flag) {
                    ret = ret.details
                    that.shopName = ret[0].name
                    that.from.shop = ret[0].shop_id
                    that.from.vip = ret[0].vip
                    that.shopList = ret
                    that.getShopProjectList()
                    that.getUserCarList()
                } else {
                    Toast(ret.info)
                }
                
            })
        },
        getUserCarList(){
            var that = this
            that.axios.get(UserCarApi, {params:{shop:this.from.shop}}).then((ret) => {
                that.carName = ret[0].name
                that.from.car = ret[0].id
                that.carList = ret
            })
        },
        getShopProjectList(){
            var that = this
            that.axios.get(ShopProjectApi, {params:{shop:this.from.shop}}).then((ret) => {
                that.shopProjectList = ret
                that.categoryName = ret[0].category.name
                that.category = ret[0].category.id
                that.projectList =  ret[0].service
                that.projectName = ret[0].service[0].name
                that.from.project_id = ret[0].service[0].id
                ret.forEach(item => {
                    that.categoryList.push(item.category)
                });
            })
        },
        onDateConfirm(date){
            this.date = moment(date).format('YYYY-MM-DD');
            this.dateShowPicker = false;
        },
        onTime1Confirm(time) {
            console.log(time)
            this.time1 = time;
            this.showPicker1 = false;
        },
        onTime2Confirm(time) {
            this.time2 = time;
            this.showPicker2 = false;
        },
        filter(type, options) {
            if (type === 'minute') {
                return options.filter((option) => option % 15 === 0);
            }
            return options;
        },
        postFrom(){
            this.from.start_time = moment(`${this.date} ${this.time1}`).toDate()
            this.from.end_time = moment(`${this.date} ${this.time2}`).toDate()
            var that = this
            if(that.from.project_id==null||that.from.project_id==0){
                Toast('请选择服务项目！')
                return
            }
            that.axios.post(BookingApi, that.from).then((ret) => {
                console.log(ret)
                Toast('创建完成')
                that.clickback()
            }).catch(function (error) {
                Toast(error)
            })
        },
        clickback() {
            try {
                this.$router.go(-1)
            } catch {
                this.$router.push(`/nt/user/booking`)
            }
        }
    }
}
</script>

<style lang="less" scoped>
</style>